<template>
    <a-modal
        title="添加链接"
        :visible="isLink"
        :confirm-loading="false"
        :centered="true"
        @cancel="close"
        width="960px"
        :maskClosable="false"
    >
     <template slot="footer">
                <a-button  @click="close">取消</a-button>
                <a-button :disabled="linkListDataShow"  type="primary"  @click="submitOne">确定</a-button>
             </template>
       <a-spin :spinning="linkListDataShow">
            
            <div class="org-box">
            <div class="org-left">
                <div style="display: flex">
                    <a-tree-select
                        v-model="columnId"
                        style="width: 100%"
                        :dropdown-style="{
                            maxHeight: '400px',
                            overflow: 'auto',
                        }"
                        :tree-data="treeData"
                        placeholder=""
                        :treeDefaultExpandedKeys="treeDefaultExpandedKeys"
                        @change="getLinksPage"
                    >
                    </a-tree-select>
                    <el-input
                        placeholder="搜索标题"
                        v-model="value"
                        class="input-with-select"
                    >
                        <el-button
                            slot="append"
                            icon="el-icon-search"
                            @click="getLinksPage"
                        ></el-button>
                    </el-input>
                </div>
                <el-checkbox-group
                    v-model="checkedList"
                    style="margin: 16px 0"
                    class="group-box"
                    @change="setCheckedName($event)"
                >
                    <el-checkbox
                        v-for="(option, optionIndex) in plainOptions"
                        :label="option.id"
                        :key="optionIndex"
                        ><div class="overflow">
                            <span :title="option.title">{{
                                option.title
                            }}</span>
                        </div></el-checkbox
                    >
                </el-checkbox-group>
                <a-pagination
                    v-model="current"
                    :total="total"
                    :pageSize='5'
                    size="small"
                    show-less-items
                    class="pagination"
                    @change="onShowSizeChange"
                />
            </div>
            <div class="org-right">
                <div class="select-number">
                    <div class="number">已选{{ checkedList.length }}个链接</div>
                    <a @click="toCustomLink" class="number">添加自定义链接</a>
                    <a @click="clear" class="number">清空</a>
                </div>
                <div class="one-box">
                      <div
                    v-for="(item, index) in checkedInfo"
                    class="one"
                    :key="index"
                >
                    <div class="name">{{ item.title }}</div>
                    <span @click="deleteFn(index)" class="icon-close"></span>
                </div>
                <div
                    v-for="(item, index) in customLinkList"
                    class="one"
                    :key="index"
                >
                    <div class="name">
                        <span
                            class="icon-st-doc-edit"
                            @click="eidtCustomLink(index)"
                        ></span>
                        {{ item.title }}
                    </div>
                    <span
                        @click="deleteCustomLink(index)"
                        class="icon-close"
                    ></span>
                </div>
                </div>
            </div>
        </div>
       </a-spin>
        
        <a-modal
            title="添加自定义链接"
            :visible="customLinkShow"
            :confirm-loading="false"
            @ok="addCustomLink"
            @cancel="closeCustomLink"
            width="600px"
            :centered="true"
            okText="导入"
        >
            <el-form
                ref="ruleForm"
                label-width="100px"
                class="demo-ruleForm"
                :model="ruleForm"
                :rules="rules"
            >
                <el-form-item label="链接标题" prop="title">
                    <el-input v-model="ruleForm.title"></el-input>
                </el-form-item>
                <el-form-item label="链接地址" prop="linkUrl">
                    <el-input v-model="ruleForm.linkUrl"></el-input>
                </el-form-item>
            </el-form>
        </a-modal>
    </a-modal>
</template>
<script>
import { columnTree, selectLinksPage } from "./manuscripts.js";
export default {
    props: {
        isLink: {
            type: Boolean,
            default: false,
        },
        defultColumnId: {
            type: Number,
            default: null,
        },
        LinkIds: {
            type: Array,
            default: () => {
                return [];
            },
        },
    },
    data() {
        return {
            value: "",
            checkedList: [],
            linkListDataShow:true,
            plainOptions: [],
            treeDefaultExpandedKeys:[],
            plainOptionsHistry:[],
            treeData: [],
            checkedInfo: [], //选中的数据
            columnId: "",
            siteId: Number(sessionStorage.getItem("siteId")),
            result: [],
            current: 1,
            size: 5,
            total: 0,
            customLinkShow: false,
            customLinkList: [],
            ruleForm: {
                title: "",
                linkUrl: "",
                type: 1,
            },
            rules: {
                title: [
                    {
                        required: true,
                        message: "输入链接标题",
                        trigger: "blur",
                    },
                ],
                linkUrl: [
                    {
                        required: true,
                        message: "输入链接地址",
                        trigger: "blur",
                    },
                ],
            },
        };
    },
    mounted() {
        this.columnId = this.defultColumnId;
        if (this.LinkIds && this.LinkIds.length > 0) {
            this.checkedList = this.LinkIds;
        }
    },
    watch: {
        // checkedList(){
        //     // let arr =[]
        //     this.plainOptions.forEach(item=>{
        //         this.checkedList.map(id=>{
        //             if(id == item.id)this.checkedListInfo.push(item)
        //         })
        //     })
        //     // this.checkedListInfo = arr
        // }
    },
    methods: {
        onShowSizeChange(current) {
            this.current = current;
            this.getLinksPage();
        },
        handleSizeChange(current, pageSize) {
            this.$emit("handleSizeChange", pageSize);
        },
        close() {
            this.$emit("colseChooseLink");
        },
        open() {
            this.$emit("openLink");
        },
        submitOne() {
            const _this = this;
            this.$emit("setLinkIds", {
                LinkIds: this.checkedList,
                LinkInfo: this.checkedInfo.concat(this.customLinkList),
                customLinkList: this.customLinkList,
            });
        },
        closeCustomLink() {
            this.customLinkShow = false;
            this.ruleForm = {
                        title: "",
                        linkUrl: "",
                        type: 1,
                    };
        },
        addCustomLink() {
              this.$refs.ruleForm.validate((valid) => {
                if(valid){
                    this.customLinkList.push(this.ruleForm);
                    this.ruleForm = {
                        title: "",
                        linkUrl: "",
                        type: 1,
                    };
                    this.customLinkShow = false;
                    this.open();
                }
              })
        },
        deleteFn(index) {
            let list = JSON.parse(JSON.stringify(this.checkedList));
            list.splice(index, 1);
            this.checkedList = JSON.parse(JSON.stringify(list))
            let listInfo  =  JSON.parse(JSON.stringify(this.checkedInfo));
            listInfo.splice(index, 1);
            this.checkedInfo = JSON.parse(JSON.stringify(listInfo))
        },
        clear() {
            this.checkedList = [];
            this.customLinkList = [];
            this.checkedInfo = [];
        },
        getColumnTree() {
            const _this = this;
            columnTree({
                columnName: _this.columnName,
                siteId: _this.siteId,
            }).then((res) => {
                if (res.code == 0) {
                    _this.treeData = res.data;
                    _this.treeDefaultExpandedKeys = [res.data[0].id]
                    _this.columnId = res.data[0].id;
                    this.getLinksPage();
                    let options = JSON.stringify(res.data)
                        .replace(/columnName/g, "title")
                        .replace(/id/g, "value");
                    _this.treeData = JSON.parse(
                        JSON.stringify(JSON.parse(options))
                    );
                }
            });
        },
        //链接列表
        getLinksPage() {
            const _this = this;
            this.linkListDataShow = true;
            let reqData = {
                value: _this.value,
                siteId: _this.siteId,
                columnId: _this.columnId,
                current: _this.current,
                size: _this.size,
            };
            selectLinksPage(reqData).then((res) => {
                if (res.code == 0) {
                    _this.plainOptions = res.data.records;
                    for (let index = 0; index < res.data.records.length; index++) {
                        const element = res.data.records[index];
                        element.columnId = this.columnId;
                    }
                    _this.plainOptionsHistry.push(...res.data.records)
                    _this.current = res.data.current;
                    _this.size = res.data.size;
                    _this.total = res.data.total;
                }
                 this.linkListDataShow = false;
            });
        },
        setCheckedName(e) {
            const _this = this;
             for (let index = 0; index <  _this.plainOptionsHistry.length; index++) {
                const element =  _this.plainOptionsHistry[index];
                element.screenId = element.maId || element.id;
            }
            var obj = {};
            _this.plainOptionsHistry = _this.plainOptionsHistry.reduce(function(item, next) {
                obj[next.screenId] ? '' : obj[next.screenId] = true && item.push(next);
                return item;
            }, []);
            
            _this.checkedInfo = []
            _this.plainOptionsHistry.map((item) => {
                if (e.indexOf(item.screenId) != -1){
                    _this.checkedInfo.push(item)
                };
            });
        },
        toCustomLink() {
            this.customLinkShow = true;
            //this.close();
        },
        deleteCustomLink(index) {
            this.customLinkList.splice(index, 1);
        },
        deleteCustomLink2(item) {
            this.customLinkList = this.customLinkList.filter((LinkItem) => {
                return LinkItem.title != item.title;
            });
        },
        eidtCustomLink(index) {
            this.ruleForm = this.customLinkList[index];
            this.customLinkList.splice(index, 1);
            this.customLinkShow = true;
        },
        setLinkInfoList(data) {
            this.customLinkList = JSON.parse(JSON.stringify(data.customLinkList));
            this.checkedInfo = JSON.parse(JSON.stringify(data.LinkInfo));
            for (let index = 0; index <  this.checkedInfo.length; index++) {
                const element =   this.checkedInfo[index];

                for (let indexTwo = 0; indexTwo < this.customLinkList.length; indexTwo++) {
                    const elementTwo = this.customLinkList[indexTwo];
                    if(element.id == elementTwo.id){
                         this.checkedInfo.splice(index,1)
                    }
                }
            }
            
            this.plainOptionsHistry.push(...this.checkedInfo)
            let arrayIds = [];
            for (let index = 0; index <  data.LinkInfo.length; index++) {
                const element =  data.LinkInfo[index];
                arrayIds.push(element.maId || element.id);
            }
            this.checkedList = arrayIds;
        },
    },
};
</script>
<style lang="less" scoped>
/deep/.ant-modal-body {
    padding: 0 24px;
}
/deep/.ant-modal-title {
    font-weight: bold;
}
/deep/.ant-modal-header {
    border-bottom: none;
}
/deep/.ant-modal-footer {
    border-top: none;
    padding-bottom: 20px;
    padding-top: 20px;
}
.org-box {
    height: 330px;
    border-radius: 4px;
    border: solid 1px #e0e3e9;
    display: flex;
    .org-left {
        border-right: solid 1px #e0e3e9;
        flex: 1;
        height: 100%;
        padding: 20px;
        overflow-y: auto;
        position: relative;
        /deep/.el-input__inner {
            border-right: none;
            border-top-right-radius: 0;
            border-bottom-right-radius: 0;
        }
        /deep/ .el-checkbox__input {
            margin-top: -5px;
        }
        /deep/.el-input-group--append .el-input__inner,
        .el-input-group__prepend {
            border-radius: 0;
        }
        /deep/ .el-checkbox {
            display: block;
        }
        .pagination {
            position: absolute;
            bottom: 5px;
        }
    }
    .org-right {
        flex: 1;
        height: 100%;
        overflow-y: auto;
        .select-number {
            display: flex;
            justify-content: space-between;
            padding-left: 12px;
            padding-right: 12px;
            padding-top: 24px;
            .number {
                font-weight: 500;
            }
        }
        .one {
            display: flex;
            align-items: center;
            justify-content: space-between;
            color: #1890ff;
            background: #ecf5ff;
            margin: 10px 20px;
            border-radius: 5px;
            padding: 0 10px;
            .name {
                font-weight: 400;
                overflow: hidden;
                text-overflow: ellipsis; 
                width:90%;
                height: 32px;
                line-height: 32px;
                white-space: nowrap;
            }
            .icon-close:before {
                color: #1890ff;
            }
            .icon-st-doc-edit:before {
                color: #1890ff;
            }
        }
    }
    /deep/.ant-select-selection--single {
        height: 40px;
    }
    /deep/.ant-select-selection {
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
        border-right: none;
    }
    /deep/.el-checkbox {
        margin-bottom: 10px;
    }
}
.btn {
    margin-top: 24px;
    text-align: right;
}
.overflow {
    width: 250px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    -o-text-overflow: ellipsis;
}
/deep/ .icon-close:before{
    position: relative;
    cursor: pointer;
    width: 12px;
    height: 12px;
    z-index: 1;
  }
   @media screen and (max-width: 720px) {
            .org-box{
                height: 65vh;
                display: block;
            }
            .org-box .org-left{
                 height: 42vh;
            }
            .group-box{
                 height: 22vh;
            }
            .org-box .org-right{
                .one-box{
                    height: 15vh;
                    overflow: auto;
                }
            }
            .org-box .org-left{
                border-right: none;
            }
            .org-box .org-right .select-number{
                padding-top: 12px !important;
            }
            /deep/ .ant-select-enabled{
                width: 40% !important;
            }
    }
</style>